/**
 * Přidělená role uživateli, neobsahuje aktivnost.
 * Může obsahovat i kompetence.
 */
export interface IAssignedRole {
    /**
     * Identifikátor role
     */
    id: string;
    /**
     * Zda je role implicitní
     */
    implicit: boolean;
    /**
     * Logický název role
     */
    name: string;
    /**
     * Fyzický název role
     */
    code: string;
    /**
     * Identifikátor role uživatele
     */
    userRoleId?: string;
    /**
     * Seznam kompetenčních okruhů přiřazených k této roli
     */
    competenceRanges?: IAssignedCompetence[];
}

/**
 * Kompetenční okruh
 */
export interface IAssignedCompetence {
    /**
     * Identifikátor kompetenčního okruhu
     */
    id: string;
    /**
     * Zda je okruh implicitní
     */
    implicit: boolean;
    /**
     * Logický název okruhu
     */
    name: string;
    /**
     * Fyzický název okruhu
     */
    code: string;
    /**
     * Identifikátor role, ke které je okruh navázaný
     */
    userRoleId?: string;
}

/**
 * Asociativní kolekce všech rolí přidělených uživateli.
 * @param roleID klíčem je id dané role
 */
export interface IAssignedRoles {
    [roleID: string]: IAssignedRole;
}

/**
 * Struktura popisující aktivnost role uživatele.
 */
export interface IUserRoleActivity {
    id: string;
    active: boolean;
    ranges?: IUserCompetenceActivity[];
}

/**
 * Struktura popisující aktivnost kompetenčního okruhu.
 */
export interface IUserCompetenceActivity {
    id: string;
    active: boolean;
}
